<template>
  <div>
    <v-card tile flat>
      <v-toolbar tile card flat dense color="theme_primary" class="white--text">
        <v-spacer></v-spacer>
        <v-toolbar-title class="white-text text-capitalize"
          >Choose supplier</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-toolbar-side-icon>
          <v-icon color="white">receipt</v-icon>
        </v-toolbar-side-icon>
      </v-toolbar>
      <v-card-text>
        <v-autocomplete
          prepend-icon="store"
          :items="supplierCompanies"
          item-value="id"
          item-text="name"
          v-model="currentScoreCost.supplier_id"
          background-color="white"
          browser-autocomplete="noautocomplete"
          box
          label="Supplier Company"
        />
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn @click="close" flat color="error">
          <v-icon small class="pr-2">close</v-icon>Cancel
        </v-btn>
        <v-spacer></v-spacer>

        <v-btn @click="applyToAllExpeditions" flat color="success">
          <v-icon small class="pr-2">mdi-check-all</v-icon>Apply to all
          expeditions
        </v-btn>

        <v-btn @click="save" depressed small color="success">
          <v-icon small class="pr-2">mdi-check</v-icon>Apply to this expedition
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SCORE_COST_UPDATE from "../../graphql/score_costs/update.gql";
import SCORE_COST_APPLY from "../../graphql/score_costs/apply.gql";
export default {
  name: "scoreCostSupplier",
  props: {
    editedScoreCost: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      billDialog: false,
      currentScoreCost: null,
    };
  },
  computed: {
    ...mapGetters("commonStore", ["suppliers", "serviceSuppliers"]),
    supplierCompanies() {
      /* score_cost invoice */
      if (this.editedScoreCost.supplier_type_id)
        return this.serviceSuppliers(this.editedScoreCost.supplier_type_id);
      else return this.suppliers;
    },
  },
  methods: {
    applyToAllExpeditions() {
      this.sendMutation(
        "apply",
        "service supplier to expeditions",
        SCORE_COST_APPLY,
        this.currentScoreCost
      ).then((data) => {
        this.close();
      });
    },
    save() {
      this.sendMutation(
        "update",
        "service supplier",
        SCORE_COST_UPDATE,
        this.currentScoreCost
      ).then((data) => {
        this.close();
      });
    },
    close() {
      this.$emit("closeBillDialog");
    },
    initScoreCost() {
      this.currentScoreCost = {
        id: this.editedScoreCost.id,
        supplier_id: this.editedScoreCost.supplier_id,
        name: this.editedScoreCost.name,
      };
    },
  },
  created() {
    this.initScoreCost();
  },
  watch: {
    editedScoreCost() {
      this.initScoreCost();
    },
  },
};
</script>

<style lang="stylus" scoped></style>
